import { flow, iots, struct } from '@code-expert/prelude';
import { CourseUrl, ExerciseId, SemesterId, TaskId } from '/imports/domain';
import { end, formatRoute, lit, query, type, url } from '/imports/modules/Routing';
import { TrueFromOne } from '/imports/utils/codecs';

export const printSlug = 'print';

const baseRoute = url(
  lit(printSlug),
  type('courseUrl', CourseUrl),
  type('semester', SemesterId),
  type('exerciseId', ExerciseId),
);

// -------------------------------------------------------------------------------------------------
// Exercise print view
// -------------------------------------------------------------------------------------------------

export const exercisePrintViewRoute = url(baseRoute, end);

export interface ExercisePrintViewParams {
  courseUrl: CourseUrl;
  semester: SemesterId;
  exerciseId: ExerciseId;
}

export const exercisePrintViewPath = (args: ExercisePrintViewParams): string =>
  formatRoute(exercisePrintViewRoute)(args);

// -------------------------------------------------------------------------------------------------
// Task print view
// -------------------------------------------------------------------------------------------------

export const taskPrintViewRoute = url(
  baseRoute,
  type('taskId', TaskId),
  query(iots.exact(iots.partial({ solution: TrueFromOne, selection: iots.string }))),
  end,
);

interface TaskPrintViewParams extends ExercisePrintViewParams {
  taskId: TaskId;
  solution: boolean;
  selection?: string;
}

export type TaskPrintViewUrlParams = Omit<TaskPrintViewParams, 'solution'> & { solution?: true };

export const taskPrintViewPath: (_: TaskPrintViewParams) => string = flow(
  struct.evolvePartial({ solution: (solution) => (solution ? true : undefined) }),
  formatRoute(taskPrintViewRoute),
);
